import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatRadioModule} from "@angular/material/radio";
import {MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatSnackBarModule} from "@angular/material/snack-bar";

import {FundAiSetupDialogComponent} from "./fund-ai-setup-dialog/fund-ai-setup-dialog.component";
import {FundAiSetupStatusChipComponent} from "./fund-ai-setup-status-chip/fund-ai-setup-status-chip.component";
import {FundAiSetupViewerPageComponent} from "./fund-ai-setup-viewer-page/fund-ai-setup-viewer-page.component";
import {ConfirmDialogComponent} from "./confirm-dialog/confirm-dialog.component";

@NgModule({
    declarations: [
        FundAiSetupDialogComponent,
        FundAiSetupStatusChipComponent,
        FundAiSetupViewerPageComponent,
        ConfirmDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatCheckboxModule,
        MatRadioModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatExpansionModule,
        MatSnackBarModule
    ],
    exports: [
        FundAiSetupStatusChipComponent
    ]
})
export class FundAiSetupModule {}
